module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return ((!_vm.isMobile || !_vm.measure) && _vm.wfsSearchConfig && _vm.wfsSearchConfig.layersToQuery) ? _c('div', {
    attrs: {
      "id": "search"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.noop($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "keyup": _vm.goSearching,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), (_vm.results.length) ? _c('div', {
    staticClass: "columns",
    attrs: {
      "id": "search-results"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        (_vm.results = [])
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, _vm._l((_vm.results), function(result) {
    return _c('search-results', _vm._b({
      key: result.id
    }, 'search-results', {
      result: result,
      clickHandler: _vm.clickHandler
    }, false))
  }), 1)]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c99529ba","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search.vue
// module id = 642
// module chunks = 2